import { Component } from '@angular/core';
import { ButtonModule, Colors } from '@coreui/angular';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface IAggridCustomButton extends ICellRendererParams {
  label: string;
  variant?: 'ghost' | 'outline' | ''; //optional
  color: Colors;
  size?: 'sm' | 'lg' | ''; // optional
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: any; //TODO function type
}

@Component({
  selector: 'smarsh-aggrid-custom-button',
  standalone: true,
  imports: [ButtonModule],
  template: `<button
    cButton
    [color]="params.color"
    [variant]="params.variant"
    [size]="params.size"
    (click)="onClick()">
    {{ params.label }}
  </button>`,
  styles: []
})
export class AggridCustomButtonComponent implements ICellRendererAngularComp {
  params: IAggridCustomButton;

  agInit(params: IAggridCustomButton): void {
    this.params = params;
    this.params.size = params.size || 'sm';
  }

  refresh(): boolean {
    return true;
  }

  onClick() {
    this.params.onClick(this.params.data);
  }
}
